<template>
  <svg
    class="svg-icon icon-default-avatar"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M521.142857 1005.458286c-207.030857 0-374.857143 11.282286-374.857143-117.540572 0-106.038857 65.883429-197.065143 177.92-256.969143 55.149714-29.494857 128.676571 23.350857 196.937143 23.350858 77.842286 0 157.750857-49.956571 217.673143-14.884572 99.437714 58.221714 157.184 138.971429 157.184 248.502857 0 128.822857-167.826286 117.540571-374.857143 117.540572zM512 599.168c-116.132571 0-210.285714-90.057143-210.285714-201.142857s94.153143-201.142857 210.285714-201.142857 210.285714 90.057143 210.285714 201.142857-94.153143 201.142857-210.285714 201.142857z"
    >
    </path>
  </svg>
</template>

<script>
export default {
  name: 'SvgDefaultAvatar',
};
</script>

<style></style>
